import React, { PureComponent } from 'react';
import Infinite from 'react-infinite';
import LoadingReplace from 'appSrc/components/Shards/Loading/LoadingReplace';
import { Table } from 'appSrc/components/UI';
import style from './styles/style.module.css';

class InfiniteTable extends PureComponent {
    constructor( props ) {
        super( props );

        this.state = {
            isInfiniteLoading: false,
            edgeOffset: this.props.loadMore ? 200 : undefined,
        };
    }
    loadMore = () => {
        if( this.props.loadMore ) {
            this.setState( { isInfiniteLoading: true } );
            this.props.loadMore()
            .then( ( response ) => {
                var newOffset = response.length > 0 ? this.state.edgeOffset : undefined;
                this.setState( { isInfiniteLoading: false, edgeOffset: newOffset } );
            } );
        } else {
            this.setState( { edgeOffset: undefined } );
        }
    }

    render() {
        const { children } = this.props;

        return (
            <Infinite className={ `dl-table ${ style.infiniteTable } ${ this.props.className }` }
            infiniteLoadBeginEdgeOffset={ this.state.edgeOffset }
            loadingSpinnerDelegate={ <LoadingReplace /> }
            preloadAdditionalHeight={ Infinite.containerHeightScaleFactor( 1.5 ) }
            isInfiniteLoading={ this.state.isInfiniteLoading }
            onInfiniteLoad={ this.loadMore }
            elementHeight={ this.props.elementHeight }
            useWindowAsScrollContainer>
                { children }
            </Infinite>
        );
    }
    static Head = ( props ) => {
        return ( <Table.Head { ...props } /> );
    }
    static Body = ( props ) => {
        return ( <Table.Body { ...props } /> );
    }
    static Row = ( props ) => {
        return ( <Table.Row { ...props } /> );
    }
    static Cell = ( props ) => {
        return ( <Table.Cell { ...props } /> );
    }
}
InfiniteTable.defaultProps = {
    className: '',
    elementHeight: 200,
};

export default InfiniteTable;
